import store from '@/store';
import client from './apiCommonConnector';
import utils from './utils';

export default {
  async getCurrent() {
    const userResponse = await client().get('/user');
    return userResponse.data;
  },

  async create(params) {
    try {
      const createUserResponse = await client().post('/users', params);
      return createUserResponse.data.id;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de la création de l'utilisateur",
        detail: "Une erreur s'est produite lors de la création de l'utilisateur, veuillez réessayer.",
      });
      return null;
    }
  },

  async getById(userId) {
    try {
      const userResponse = await client().get(`/users/${userId}`);
      return userResponse.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération de l'utilisateur, veuillez réessayer.",
      });
      return null;
    }
  },

  async get(size = 100, start = 0) {
    try {
      const usersResponse = await client().get('/users', { params: { start, size } });
      return usersResponse.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération de la liste des utilisateurs, veuillez réessayer.",
      });
      return utils.createEmptyListResponse();
    }
  },

  async search({ size = 100, start = 0, filters = [] }) {
    try {
      const usersResponse = await client().post('/users/search', { start, size, filters });
      return usersResponse.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération de la liste des utilisateurs, veuillez réessayer.",
      });
      return utils.createEmptyListResponse();
    }
  },

  async uploadLogoById(userId, file, fileType) {
    try {
      await client().post(`/users/${userId}/image`, file, { headers: { 'Content-Type': fileType } });
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'ajout du logo",
        detail: "Une erreur s'est produite lors de l'upload du logo de l'utilisateur, veuillez réessayer.",
      });
    }
  },

  async deleteLogoById(userId) {
    try {
      await client().delete(`/users/${userId}/image`);
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de la suppression du logo',
        detail: "Une erreur s'est produite lors de la suppression du logo de l'utilisateur, veuillez réessayer.",
      });
    }
  },

  async deleteByIds(userIds) {
    try {
      await client().delete('/users', { data: userIds });
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: `Echec de la suppression ${userIds.length > 1 ? 'des utilisateurs' : "de l'utilisateur"}`,
        detail: `Une erreur s'est produite lors de la supression ${userIds.length > 1 ? 'des utilisateurs' : "de l'utilisateur"}, veuillez réessayer.`,
      });
    }
  },

  async deleteById(userId) {
    await this.deleteByIds([userId]);
  },

  async put(userId, params) {
    try {
      await client().put(`/users/${userId}`, params);
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'édition de l'utilisateur",
        detail: "Une erreur s'est produite lors de l'édition de l'utilisateur, veuillez réessayer.",
      });
    }
  },
};
